import ReducerUtils from "../../../utils/ReducerUtils"
import Actions from "../../../model/constant/actions"

const Ads = ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVING_ADS_STATISTICS] : (_,action)=>action.status
})

export default Ads
